import {DateTime} from "luxon";
import {iso8601DateTimeValidationPattern} from "@vesta/global-common-typescript/utilities/validationPatterns";

export const graphsXAxisTickFormatter = (value: string | number) => {
    if (typeof value !== "string") {
        return String(value);
    }
    if (`${value}`.length <= 9) {
        return value;
    }
    let parsedDate = DateTime.fromFormat(value, "yyyy-MM-dd");

    if (parsedDate.invalidReason !== null) {
        const isValueIsoDate = new RegExp(iso8601DateTimeValidationPattern).test(value);
        if (isValueIsoDate === true) {
            parsedDate = DateTime.fromISO(value);
            if (parsedDate.invalidReason !== null) {
                return value;
            }
        } else {
            return value;
        }
    }
    return parsedDate.toFormat("LLL dd, yyyy");
};
